import * as React from "react";
import Orders from "./Orders.js";
const OrdersContainer = ({ shouldShowOrderDate }) => {
  return /* @__PURE__ */ React.createElement(Orders, { shouldShowOrderDate });
};
export {
  OrdersContainer as default
};
//# sourceMappingURL=OrdersContainer.js.map
